import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import moment from 'moment-timezone';

@Component({
  standalone: true,
  selector: 'crm-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  imports: [RouterModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthLayoutComponent {
  public readonly footerYear =
    moment().year() === 2022
      ? '2022'
      : `2022-${moment().year()}`;
}
